import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import Input from '../../components/input/Input';

import { CheckEmail, inspectionPassword } from '../../common/CheckedValidation';
import WithSetUserManage from '../../common/WithSetUserManage';
import Modal from '../../containers/baseModal/BaseModal';
import { getItem, setItem, removeItem } from '../../common/StorageUtils';
import _Fetch from '../../common/Fetches';
import { setCookie } from '../../common/Utils';

class SignUp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      password: '',
      confirmPassword: '',
      checkOverlapEmail: false,
      isModal: false,
      bodyText: '',
    };

    this.onNext = this.closeModal;
  }

  componentDidMount() {
    window.document.body.style.backgroundColor = '#fafafa';
    window.document.body.addEventListener('keyup', this.onkeyup);
  }

  componentWillUnmount() {
    window.document.body.removeEventListener('keyup', this.onkeyup);
  }

  onkeyup = (e) => {
    if (e.keyCode === 13) return this.signUpFetch();

    return null;
  };
  successfullyLogin = async (userData) => {
    setCookie('userData', JSON.stringify(userData));
    // 세션에 담긴 카트 아이템을 할당
    const cartData = getItem('cart') === null ? [] : getItem('cart');

    // 카트 머지: 이미지는 ConfirmPurchaseAlert 에서 S3 업로드 완료, 여기선 DB cart_insert 만.
    // (설계 상세: Login.js successfullyLogin 참조)
    const remaining = [];
    const failedItems = [];
    for (let i = 0; i < cartData.length; i += 1) {
      const item = cartData[i];
      try {
        const api = getItem('restAPI').model_desc.cart_insert;
        const body = {
          cart: {
            pid_user: userData.user.pid_user,
            ...item,
          },
        };
        await _Fetch(api, '', body);
      } catch (e) {
        console.error('cart_insert failed during merge', e);
        remaining.push(item);
        failedItems.push({ item, error: e });
      }
    }

    if (remaining.length === 0) {
      removeItem('cart');
    } else {
      setItem('cart', remaining);
      console.error('Cart sync partial failure:', failedItems);
      alert(`Could not transfer ${remaining.length} cart item(s). Please retry from the cart page.`);
    }

    try {
      const url = getItem('restAPI').model_desc.cart_count_my;
      const query = `?pid_user=${userData.user.pid_user}`;
      const res = await _Fetch(url, query, []);
      const num = Object.values(res[0])[0];
      const { actions } = this.props;
      actions.setCount(num);
    } catch (e) {
      console.error('cart_count_my failed', e);
    }

    this.setState({ isLoaded: false });
    return this.props.history.push('/cart');
  };
  async signUpFetch() {
    const { userManage } = this.props;
    try {
      if (!this.state.email) {
        return this.openModal('Please enter your email address');
      }

      if (!CheckEmail(this.state.email)) {
        return this.openModal('Please enter a valid email address (Ex: johndoe@domain.com).');
      }

      const checkEmail = await this.props.userManage.checkId(this.state.email);

      if (!this.state.password || !this.state.confirmPassword) {
        return this.openModal('Please enter your password');
      }

      if (
        !inspectionPassword(this.state.confirmPassword, this.state.password)
      ) {
        return this.openModal('This field must be the same as Password');
      }
      if (checkEmail) {
        const data = {
          user: {
            id: this.state.email,
            user_name: 'none',
            user_type: 0,
          },
          user_auth: {
            typ_login: 1,
            pw: this.state.password,
          },
        };
        const isSignUp = await this.props.userManage.signUp(data);
        console.log(isSignUp);
        if (isSignUp.status === 1504) {
          return this.openModal('Password is too short.');
        }
        if (isSignUp.status === 1506) {
          return this.openModal('There is already an account with this email address.');
        }
        if (isSignUp > 0) {
          const userData = await userManage.login(this.state.email, this.state.password);
          this.successfullyLogin(userData);
          this.onNext = () => this.props.history.push('/');
          return this.openModal('You have successfully signed up.');
          // return this.props.history.push('/');
        }
        return this.openModal(isSignUp.results);
      }
      return null;
    } catch (e) {
      return this.openModal('The network is in an insecure state. Please try again.');
    }
  }

  openModal = (bodyText) => {
    this.setState({
      isModal: true,
      bodyText,
    });
  };

  closeModal = () => {
    this.setState({
      isModal: false,
      bodyText: '',
    });
  };

  render() {
    const { history, userManage } = this.props;
    const { isModal, bodyText } = this.state;

    if (!userManage) return <div style={styles.containerEmpty} />;

    return (
      <div className="signup-container" style={styles.container}>
        <Modal
          isModal={isModal}
          bodyText={bodyText}
          onClose={this.closeModal}
          onNext={this.onNext}
        />
        <div className="signup-inner" style={styles.inner}>
          <p className="signup-title" style={styles.title}>Sign Up</p>

          <div className="signup-overlap-notice" style={styles.overlapNoticeBox(this.state.checkOverlapEmail)}>
            This email address is already associated with an account. If this
            account is yours, you can &nbsp;
            <u
              onClick={() => history.push('/reset/password')}
              role="button"
              tabIndex="0"
              style={styles.resetPwText}
            >
              reset your password
            </u>
          </div>

          <Input
            className="signup-input"
            onChange={email => this.setState({ email })}
            style={styles.input(
              20,
              this.state.email.length > 0 && !CheckEmail(this.state.email),
            )}
            placeholder="Email address"
            placeholderColor="#868686"
            type="text"
          />
          <p
            className="signup-valid-notice"
            style={styles.vaildNotice(this.state.email.length > 0 && !CheckEmail(this.state.email))}
          >
            Enter a valid email address
          </p>

          <Input
            className="signup-input"
            onChange={password => this.setState({ password })}
            style={styles.input()}
            placeholder="Password"
            placeholderColor="#868686"
            type="password"
          />

          <Input
            className="signup-input"
            onChange={confirmPassword => this.setState({ confirmPassword })}
            style={styles.input(
              15,
              this.state.confirmPassword.length > 0 &&
                this.state.password.length > 0 &&
                !inspectionPassword(
                  this.state.confirmPassword,
                  this.state.password,
                ),
            )}
            placeholder="Confirm Password"
            placeholderColor="#868686"
            type="password"
          />
          <p
            className="signup-valid-notice"
            style={styles.vaildNotice(this.state.confirmPassword.length > 0 &&
                this.state.password.length > 0 &&
                !inspectionPassword(
                  this.state.confirmPassword,
                  this.state.password,
                ))}
          >
            This field must be the same as Password
          </p>

          <div
            className="signup-btn"
            role="button"
            tabIndex={-1}
            onClick={() => this.signUpFetch()}
            style={styles.accountBtn}
          >
            CREATE
          </div>
        </div>
      </div>
    );
  }
}

SignUp.propTypes = {
  history: PropTypes.object,
  userManage: PropTypes.object,
};

SignUp.defaultProps = {
  history: {},
  userManage: {},
};

const styles = {
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  containerEmpty: {
    width: '100%',
    height: 727,
  },
  inner: {
    marginTop: 50,
    marginBottom: 124,
    width: 700,
    height: 600,
    backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  title: {
    fontFamily: 'Roboto Condensed',
    fontWeight: 'bold',
    color: '#000',
    fontSize: 24,
    marginTop: 53,
  },
  input: (marginTop = 15, isVaild = false) => ({
    width: 280 - 30,
    height: 42,
    border: isVaild ? '1px solid #e85454' : '1px solid #ddd',
    outline: 'none',
    fontFamily: 'Roboto Condensed',
    fontSize: 14,
    paddingLeft: 15,
    paddingRight: 15,
    color: '#251f1b',
    marginTop,
  }),
  accountBtn: {
    cursor: 'pointer',
    width: 280,
    height: 42,
    backgroundColor: '#000',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    fontFamily: 'Roboto Condensed',
    fontSize: 12,
    color: '#fff',
    fontWeight: 'bold',

    margin: 'auto',
    marginTop: 50,
  },
  vaildNotice: isVaild => ({
    width: 280,
    display: isVaild ? 'block' : 'none',
    marginTop: 4,
    fontFamily: 'Roboto Condensed',
    fontSize: 10,
    color: '#e85454',
    textAlign: 'left',
  }),
  overlapNoticeBox: isVisble => ({
    display: isVisble ? 'block' : 'none',
    width: 280,
    height: 43,
    marginTop: 10,
    color: '#d0021b',
    fontFamily: 'Roboto Condensed',
    fontSize: 11,
  }),
  resetPwText: {
    fontFamily: 'Roboto Condensed',
    fontSize: 11,
    color: '#000',
    cursor: 'pointer',
    outline: 'none',
  },
};

export default withRouter(WithSetUserManage()(SignUp));
